// The surface a page scrolls in, for a table on it to fit the room left
// below it there: the table scrolls its own rows (its header pinned) while
// what is above it stays in view. A surface provides a function returning
// its scrolling element; DataTable fits to it when it is given no scroll
// container or max height of its own. A region that scrolls by itself
// inside such a surface (a fixed-height frame, a dialog) provides null.
import { createContext } from "react";

export const ScrollRoot = createContext(null);
